import C from '../../constants/actionTypes';

export const validations = (state = {}, action) => {
    switch (action.type) {
        case C.VALIDATIONS_FETCHED:
            return action.payload;
        default:
            return state;
    }
};
